/** @format */

import {Box, styled, Typography} from '@mui/material';

export const StyledContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(4, 8, 4, 4),
  height: '56px',
  cursor: 'pointer',
  backgroundColor: '#202020',
  '&:hover': {
    backgroundColor: '#2A2A2A',
  },
  transition: 'background-color 0.2s ease',
  position: 'relative',
}));

export const NumberCircle = styled(Box)(({theme}) => ({
  borderRadius: '100px',
  padding: theme.spacing(1),
  minWidth: '18px',
  height: '18px',
  backgroundColor: '#1976d2',
  color: '#ffffff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '14px',
  fontWeight: '400',
  flexShrink: 0,
  marginRight: theme.spacing(1),
}));

export const RecommendationText = styled(Typography)(({theme}) => ({
  color: theme.palette.text.primary,
  lineHeight: 1.4,
  fontSize: '14px',
  fontWeight: 400,
}));

export const ActionIcon = styled('div')<{isVisible: boolean}>(({theme, isVisible}) => ({
  position: 'absolute',
  right: theme.spacing(4),
  width: '16px',
  height: '16px',
  cursor: 'pointer',
  opacity: isVisible ? 1 : 0,
  transition: 'opacity 0.2s ease',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
